import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
} from "@/components/ui/select";
import { TaskStatus } from "@/consts/Task";
import { useParams } from "react-router-dom";
import { useUpdateProjectGroupsTasks } from "@/libs/react-query/hooks/useTaskQuery";
import TaskStatusLabel from "@/components/TaskStatusLabel";
import { useState } from "react";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";

export default function TaskSelect({
  status,
  taskId,
  groupId,
  disabled = false,
}: {
  status: TaskStatus;
  taskId: string;
  groupId?: string;
  disabled?: boolean;
}) {
  const { group_id = "" } = useParams();
  const [popoverOpen, setPopoverOpen] = useState(false);
  const [selectboxOpen, setSelectboxOpen] = useState(false);
  const [inputValue, setInputValue] = useState<string>("");

  const { mutate } = useUpdateProjectGroupsTasks({
    group_id: groupId || group_id,
    task_id: taskId,
  });

  const onSelectValueChange = (value: string) => {
    if (value === status) return;

    mutate(
      { status: value as TaskStatus },
      {
        onSuccess: () => {
          setPopoverOpen(true);
          setSelectboxOpen(false);
        },
      }
    );
  };

  const handleUpdateMemo = () => {
    mutate(
      { memo: inputValue },
      {
        onSuccess: () => {
          setInputValue("");
          setPopoverOpen(false);
          setSelectboxOpen(false);
        },
      }
    );
  };

  return (
    <div className="flex items-center justify-between pr-3">
      <Select
        open={selectboxOpen}
        onOpenChange={setSelectboxOpen}
        onValueChange={onSelectValueChange}
        disabled={disabled}
      >
        <SelectTrigger className="h-auto p-0 border-none bg-transparent hover:bg-transparent focus:ring-0 focus:ring-offset-0 [&>svg]:hidden">
          <TaskStatusLabel status={status} />
        </SelectTrigger>
        <SelectContent>
          {Object.values(TaskStatus).map((status) => (
            <SelectItem
              key={status}
              value={status}
              className="flex justify-center py-2 pl-1 pr-2 [&>span:first]:hidden"
              asChild
            >
              <TaskStatusLabel status={status} />
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Popover open={popoverOpen} onOpenChange={setPopoverOpen}>
        <PopoverTrigger asChild>
          <div />
        </PopoverTrigger>

        <PopoverContent className="w-[340px] h-[246px] cursor-default">
          <div className="h-full flex flex-col gap-4 rounded-lg">
            <p className="text-lg text-center text-gray-A font-semibold">
              진행상태 변경 사유 입력
            </p>
            <Textarea
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              className="resize-none flex-1"
              placeholder="사유를 입력해주세요"
            />
            <div className="flex justify-center gap-4">
              <Button
                size="trigger"
                variant="cancel"
                onClick={() => setPopoverOpen(false)}
              >
                취소하기
              </Button>
              <Button
                size="trigger"
                variant="confirm"
                onClick={handleUpdateMemo}
                disabled={!inputValue}
              >
                입력하기
              </Button>
            </div>
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
}
